import DocumentHelpUI from "@/UI/BaseComponents/Help/documentHelpUI";
import { Suspense } from "react";
import EntryFormWrapper from "./EntryFormWrapper";
export const AlignUIRender = ({
  props,
  ScreenComponent,
  objectId,
  isConfigLoaded,
}: any) => (
  <EntryFormWrapper>

    {
      isConfigLoaded ?
        <Suspense fallback={<div>Loading...</div>}>
          <ScreenComponent objectId={objectId} />
        </Suspense>
        : null
    }

    <DocumentHelpUI history={props.history} />

  </EntryFormWrapper>
);
